const executeSetHelpIconCode = (helpIconSrc, hasCurrentUser) => {
    // Function to set help icon in header bar responsively
    const helpIcon = document.querySelector(".help-icon");
    helpIcon.src = helpIconSrc;
    if (hasCurrentUser === true) {
        helpIcon.alt = "Help and Resource Center";
    } else {
        helpIcon.alt = "Help Center";
    }

    return helpIcon.src;
}

window.executeSetHelpIconCode = executeSetHelpIconCode;